
import { RefreshTime } from '@/common/enums/RefreshTime';
import { isAllowScreen } from '@/common/helpers/ModuleHelpers';
import { createNamespacedHelpers } from '@/common/vuex-composition-hooks';
import { IAuthActions, IAuthGetters, IAuthState } from '@/modules/login/types';
import router from '@/router';
import { defineComponent, onMounted, onUnmounted, reactive, toRefs } from 'vue';
import { firstUpperString } from '@/common/helpers/FirstUpperString';
import * as vueRouter from 'vue-router';
const { useActions, useState, useGetters } = createNamespacedHelpers<
  IAuthState,
  IAuthGetters,
  IAuthActions
>('auth');

interface ITab {
  id: number;
  name?: string;
  active?: boolean;
  code?: any;
  route?: string;
  module?: string;
}

interface State {
  brandtabs: ITab[];
  tabActive: any;
  allowedBrandTabs: any;
}

export default defineComponent({
  name: 'Tabs',

  setup() {
    const { setNextBillingUnit, setActiveModule, sessionUpdate } = useActions([
      'setNextBillingUnit',
      'setActiveModule',
      'sessionUpdate',
    ]);

    const { sessionUser } = useGetters(['sessionUser']);

    const { brands } = useState(['brands']);

    const state: State = reactive<State>({
      brandtabs: [],
      tabActive: '',
      allowedBrandTabs: [],
    });

    brands?.value
      ?.filter((el) => el.brandIsPrivateLabel === 'N')
      .forEach((el, index) => {
        state.brandtabs.push({
          id: index,
          name: firstUpperString(el.name),
          active: false,
          code: el.name.toUpperCase(),
          module: '5',
          route: el.name.toUpperCase(),
        });
      });

    state.brandtabs.push({
      id: state.brandtabs.length + 1,
      name: 'Totais',
      active: false,
      code: 'TOTALS',
      module: '5',
      route: 'TOTALS',
    });

    const isActiveTab = (pTabs) => {
      const route = vueRouter.useRoute();
      return pTabs.route === route.name;
    };

    state.allowedBrandTabs = state.brandtabs.filter((tab: ITab) => tab);

    const handleTabChange = async (
      tabIndex: number,
      clearRefreshTime: boolean
    ) => {
      state.allowedBrandTabs.forEach((tab: ITab) => {
        tab.active = false;
      });

      const tab = state.allowedBrandTabs[tabIndex];

      state.tabActive = tab;

      if (tab) tab.active = true;

      if (tabIndex === 0) await setNextBillingUnit();
      await setActiveModule(tab.module);

      await router.push({ name: tab?.route });

      if (clearRefreshTime) {
        clearInterval(refreshTimer);
        refreshTimer = setInterval(handleRefreshTab, RefreshTime.TIMES);
      }
    };

    const handleRefreshTab = async () => {
      let tabIndex = state.allowedBrandTabs.indexOf(state.tabActive) + 1;

      if (tabIndex >= state.allowedBrandTabs.length) {
        if (isAllowScreen('isAllowedShipmentBillingScreen'))
          await sessionUpdate(
            sessionUser.value.billingUnits[0].billingUnitCode
          );
        else tabIndex = 0;
      }

      await handleTabChange(tabIndex, false);
    };

    let refreshTimer: number;

    const init = async () => {
      const route = vueRouter.useRoute();
      state.tabActive = String((route.meta.brand as string).toUpperCase());
      const tab = state.allowedBrandTabs.find(
        (tab: ITab) => tab.code === state.tabActive
      );

      if (tab) {
        tab.active = true;
        state.tabActive = tab;
      } else {
        const tabActive = state.allowedBrandTabs[0];
        if (tabActive) {
          state.tabActive = tabActive;
          tabActive.active = true;
        }
      }

      refreshTimer = setInterval(handleRefreshTab, RefreshTime.TIMES);
    };

    onMounted(init);
    onUnmounted(() => clearInterval(refreshTimer));

    return {
      ...toRefs(state),
      isActiveTab,
      handleTabChange,
      brands,
    };
  },
});
